import React from "react";
import styled from "@emotion/styled";
import { NavLink } from "react-router-dom";

import { Drawer as MuiDrawer, ListItemButton } from "@mui/material";

import { ReactComponent as Logo } from "../../../vendor/logo.svg";
import { SidebarItemsType } from "types/sidebar";

import { SidebarNav } from "components/atoms/sidebar-nav";
import { User } from "core/types/user.types";
import { SidebarFooter } from "components/atoms/sidebar-footer";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";

const Drawer = styled(MuiDrawer)`
  border-right: 0;

  > div {
    border-right: 0;
  }
`;

const Brand = styled(ListItemButton)<{
  component?: React.ReactNode;
  to?: string;
}>`
  font-size: ${(props) => props.theme.typography.h5.fontSize};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  color: ${(props) => props.theme.sidebar.header.color};
  background-color: ${(props) => props.theme.sidebar.header.background};
  font-family: ${(props) => props.theme.typography.fontFamily};
  min-height: 56px;
  padding-left: ${(props) => props.theme.spacing(6)};
  padding-right: ${(props) => props.theme.spacing(6)};
  justify-content: center;
  cursor: pointer;
  flex-grow: 0;

  ${(props) => props.theme.breakpoints.up("sm")} {
    min-height: 64px;
  }

  &:hover {
    background-color: ${(props) => props.theme.sidebar.header.background};
  }
`;

const BrandIcon = styled(Logo)`
  margin-right: ${(props) => props.theme.spacing(2)};
  color: ${(props) => props.theme.sidebar.header.brand.color};
  fill: ${(props) => props.theme.sidebar.header.brand.color};
  width: 110%;
  height: 32px;
`;

const NovitaLink = styled(ListItemButton)<{
  component?: React.ReactNode;
  to?: string;
}>`
  flex-grow: 0;
  color: ${(props) => props.theme.sidebar.color};
  background-color: ${(props) => props.theme.sidebar.background};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  font-size: 0.8125rem;
  font-weight: ${(props) => props.theme.typography.fontWeightRegular};
  padding-left: ${(props) => props.theme.spacing(6)};
  padding-top: ${(props) => props.theme.spacing(3)};
  padding-bottom: ${(props) => props.theme.spacing(3)};
  gap: ${(props) => props.theme.spacing(3)};

  svg {
    font-size: 20px;
  }

  &:hover {
    background-color: ${(props) => props.theme.sidebar.background};
    color: ${(props) => props.theme.sidebar.header.brand.color};
  }
`;

export type SidebarProps = {
  PaperProps: {
    style: {
      width: number;
    };
  };
  variant?: "permanent" | "persistent" | "temporary";
  open?: boolean;
  onClose?: () => void;
  items: {
    title: string;
    pages: SidebarItemsType[];
  }[];
  showFooter?: boolean;
  user?: User;
};

const Sidebar: React.FC<SidebarProps> = ({
  items,
  showFooter = true,
  user,
  ...rest
}) => {
  return (
    <Drawer variant={"permanent"} {...rest}>
      <Brand component={NavLink as any} to="/">
        <BrandIcon />
      </Brand>
      <SidebarNav items={items} />
      {!!showFooter && (
        <NovitaLink component={NavLink as any} to="/news">
          <CampaignOutlinedIcon />
          Novità
        </NovitaLink>
      )}
      {!!showFooter && <SidebarFooter user={user} />}
    </Drawer>
  );
};

export default Sidebar;
